import  { useEffect, useState } from "react"

import { useTranslation } from "react-i18next"
import API from "../../common/API"
import { parsedUser } from "../../common/GetCurrentUser"
import CRUDField from "./genericCRUD/CRUDField"

type FieldSelectorModel = CRUDField & {
  onAction?: () => void
  onOpenPicker?: () => void
  actionLabel?: string
  latField?: string
  lngField?: string
  accept?: string
  onFileUpload?: (e: React.ChangeEvent<HTMLInputElement>) => void
  previewBasePath?: string
  previewClass?: string
  previewStyle?: React.CSSProperties
  placeholder?: string
}

interface FieldSelectorProps {
  model: FieldSelectorModel
  updateField: (name: string, value: unknown) => void
  obj?: Record<string, unknown>
  value?: unknown
  errors?: Record<string, unknown>
}

const FieldSelector = (props: FieldSelectorProps) => {
  const { t } = useTranslation("global")
  const [records, setRecords] = useState<unknown[]>([])
  const user = parsedUser()

  const model = props.model

  if (!model) {
    return
  }

  const requestRecords = async () => {
    let query = ""
    if (model.dependOf && props.obj) {
      query = `${model.dependOf}=${props.obj[model.dependOf]}`
    }
    const requestAPI = await API.getAction(
      model.dataSource + (query.length > 0 ? "?" + query : "")
    )

    if (requestAPI.data.status === "ok") {
      setRecords(requestAPI.data.response)
    }
  }

  const [creditCode, setCreditCode] = useState("")
  const searchCreditCode = async (code: string) => {

    const requestAPI = await API.getAction(
      `place/SearchByCode?code=${props.value}&organizationId=${user?.OrganizationId}`
    )
    if (requestAPI.data.status === "ok" && requestAPI.data.response) {
      const place = requestAPI.data.response as Record<string, unknown>
      props.updateField("name", place.name)

      let notes = ""
      if (place.phone) {
        notes += `Teléfono: ${place.phone}\n`
      }
      if (place.category) {
        notes += `Categoría: ${place.category}\n`
      }
      props.updateField("note", notes.trim())
    }
  }

  useEffect(() => {
    console.log(model)
    if (model && model.dataSource && !model.dataSourceLocal) {
      requestRecords()
    } else if (model && model.dataSourceLocal) {
      console.log(model.dataSourceLocal)
      setRecords(model.dataSourceLocal)
    }
  }, [model])

  useEffect(() => {
    if (props.obj) {
      if (model && model.dataSource && !model.dataSourceLocal) {
        requestRecords()
      }
    }
  }, [props.obj])

  const returnField = () => {
    console.log(model)
    const safeValue =
      typeof props.value === "string" || typeof props.value === "number"
        ? props.value
        : ""
    switch (model.htmlType) {
      case "email":
      case "text":
      case "date":
      case "file":
      case "number":
      case "password":
      case "color":
        return (
          <input
            type={model.htmlType}
            className={"form-control"}
            name={model.name}
            value={safeValue}
            onChange={e => {
              console.log(e.target.value)
              props.updateField(model.name, e.target.value)
            }}
          />
        )

      case "textarea":
        return (
          <textarea
            className={"form-control"}
            name={model.name}
            value={safeValue}
            onChange={e => {
              console.log(e.target.value)
              props.updateField(model.name, e.target.value)
            }}
          ></textarea>
        )

      case "select":
        return (
          <select
            className={`select form-control`}
            name={model.name}
            value={safeValue}
            onChange={e => {
              props.updateField(model.name, e.target.value)
            }}
          >
            <option value="">-</option>
            {records &&
              records.map((item, index) => {
                console.log(item)
                const valueField = model.dataSourceValueField || "id"
                const textField = model.dataSourceTextField || "name"
                const record = item as Record<string, unknown>
                return (
                  <option key={index} value={record[valueField] as string}>
                    {record[textField] as string}
                  </option>
                )
              })}
          </select>
        )

      case "bool":
        return (
          <button
            className={
              "btn " + (props.value ? "btn-primary" : "btn-outline-primary")
            }
            onClick={() => {
              props.updateField(model.name, !props.value)
            }}
          >
            {props.value ? (
              <i className="fa-solid fa-toggle-on "></i>
            ) : (
              <i className="fa-solid fa-toggle-off"></i>
            )}
          </button>
        )
      case "label":
        return <label>{String(props.value ?? "")}</label>

      case "geo": {
        const latField = model.latField || "latitude"
        const lngField = model.lngField || "longitude"
        const latValue = (props.obj as Record<string, unknown>)?.[latField] ?? ""
        const lngValue = (props.obj as Record<string, unknown>)?.[lngField] ?? ""
        const latError = (props.errors as Record<string, unknown>)?.[latField]
        const lngError = (props.errors as Record<string, unknown>)?.[lngField]
        const hasCoords = latValue !== "" && lngValue !== ""

        return (
          <div>
            <div className="d-flex gap-2 flex-wrap">
              <button
                type="button"
                className="btn btn-sm btn-secondary"
                onClick={() => model.onAction?.()}
              >
                {model.actionLabel || "Crear pin"}
              </button>
              {model.onOpenPicker && (
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => model.onOpenPicker?.()}
                >
                  <i className="fas fa-map me-2"></i>
                  Elegir en mapa
                </button>
              )}
            </div>
            <span className="d-block text-muted mt-2">{`${latValue}, ${lngValue}`}</span>
            {hasCoords && (
              <div
                className="mt-2"
                role="button"
                tabIndex={0}
                onClick={() => model.onOpenPicker?.()}
                onKeyDown={e => {
                  if (e.key === "Enter" || e.key === " ") model.onOpenPicker?.()
                }}
              >
                <div
                  style={{
                    borderRadius: "8px",
                    overflow: "hidden",
                    border: "1px solid #e5e7eb",
                    height: "140px",
                    cursor: model.onOpenPicker ? "pointer" : "default",
                  }}
                >
                  <iframe
                    title="map-preview"
                    width="100%"
                    height="140"
                    style={{ border: 0 }}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    src={`https://maps.google.com/maps?q=${latValue},${lngValue}&z=15&output=embed`}
                  />
                </div>
              </div>
            )}
            {typeof latError === "string" ? (
              <div className="invalid text-sm text-danger">{latError}</div>
            ) : null}
            {typeof lngError === "string" ? (
              <div className="invalid text-sm text-danger">{lngError}</div>
            ) : null}
          </div>
        )
      }

      case "image": {
        return (
          <div>
            <input
              type="file"
              className="form-control"
              accept={model.accept || "image/*"}
              onChange={e => model.onFileUpload?.(e)}
            />
            {props.value ? (
              <img
                alt=""
                className={model.previewClass || "img-thumbnail my-2"}
                style={model.previewStyle || { maxHeight: "160px" }}
                src={`${model.previewBasePath || ""}${props.value}`}
              />
            ) : null}
            {props.errors && props.errors[model.name] ? (
              <div className="invalid text-sm text-danger">
                {String((props.errors as Record<string, unknown>)[model.name] ?? "")}
              </div>
            ) : null}
          </div>
        )
      }

      case "creditCode": {
        return (
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              placeholder={model.placeholder || "XX-12345"}
              name={model.name}
              value={safeValue}
              onChange={e => {
                setCreditCode(e.target.value)
                props.updateField(model.name, e.target.value)
              }}
            />
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => searchCreditCode(creditCode)}
            >
              <i className="fas fa-search"></i>
            </button>
          </div>
        )
      }

      default:
        return <></>
    }
  }

  // <select
  //   className={`select w-full`}
  //   name={model.name}
  //   value={props.value ?? ""}
  //   onChange={(e) => {
  //     props.updateField(model.name, e.target.value);
  //   }}
  // >
  //   <option value="">-</option>
  //   {records &&
  //     records.map((item, index) => {
  //       console.log(item);

  //       return (
  //         <option key={index} value={item[model.dataSourceValueField]}>
  //           {item[model.dataSourceTextField]}
  //         </option>
  //       );
  //     })}
  // </select>;
  //debugger;
  if (!model) {
    return <></>
  }
  return (
    <div className={model.containerClass + " my-2"}>
      <label>
        {t(model.title || "")}
        {model.required && <i className="text-danger">*</i>}
      </label>
      <br />
      {returnField()}
      {typeof (props.errors as Record<string, unknown>)?.[model.name] === "string" ? (
        <div className="invalid text-sm text-danger">
          {String((props.errors as Record<string, unknown>)[model.name] ?? "")}
        </div>
      ) : null}
    </div>
  )
}

export default FieldSelector
